export default __webpack_public_path__ + "static/media/ptColoringSample.035de2cd3c73113d8e86a303ef83ef64.png";